import { AIIcon } from './AIIcon';

// export const AIAvatarIcon = createIconComp({ icon });

export const AIAvatarIcon = AIIcon;
